// АВТОГЕНЕРАЦИЯ из BackEnd/unitchars_defaults.json (scripts/gen-unit-stats.js).
// Базовые боевые параметры юнита по (type, rank) — показываются при наведении (вкладка Sword).
// Ключ: `${type}_${rank}`. Это базовые статы контента; индивидуальные UnitChar сервер
// шлёт только в боевых событиях (init_fight/fight_*), их здесь нет.
export const UNIT_STATS = {
  "Pawn_Warrior": {
    "health": 300,
    "health_regeneration": 0,
    "physical_damage": 120,
    "magic_damage": 0,
    "physical_resist": 0,
    "magic_resist": 0,
    "speed": 100,
    "dodge": 0,
    "stamina": 50,
    "stamina_regeneration": 5,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 57.5
  },
  "Pawn_Archer": {
    "health": 270,
    "health_regeneration": 0,
    "physical_damage": 54,
    "magic_damage": 54,
    "physical_resist": 0,
    "magic_resist": 0,
    "speed": 105,
    "dodge": 0,
    "stamina": 25,
    "stamina_regeneration": 2.5,
    "mana": 25,
    "mana_regeneration": 2.5,
    "power": 53.8
  },
  "Pawn_Mage": {
    "health": 243,
    "health_regeneration": 0,
    "physical_damage": 0,
    "magic_damage": 97,
    "physical_resist": 0,
    "magic_resist": 0,
    "speed": 102.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 50,
    "mana_regeneration": 5,
    "power": 49.75
  },
  "Knight_Warrior": {
    "health": 300,
    "health_regeneration": 0,
    "physical_damage": 120,
    "magic_damage": 0,
    "physical_resist": 0,
    "magic_resist": 0,
    "speed": 112,
    "dodge": 0,
    "stamina": 50,
    "stamina_regeneration": 7.5,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 58.95
  },
  "Knight_Archer": {
    "health": 270,
    "health_regeneration": 0,
    "physical_damage": 54,
    "magic_damage": 54,
    "physical_resist": 0,
    "magic_resist": 0,
    "speed": 117,
    "dodge": 0,
    "stamina": 25,
    "stamina_regeneration": 3.75,
    "mana": 25,
    "mana_regeneration": 3.75,
    "power": 55.25
  },
  "Knight_Mage": {
    "health": 243,
    "health_regeneration": 0,
    "physical_damage": 0,
    "magic_damage": 97,
    "physical_resist": 0,
    "magic_resist": 0,
    "speed": 114.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 50,
    "mana_regeneration": 7.5,
    "power": 51.2
  },
  "Bishop_Warrior": {
    "health": 360,
    "health_regeneration": 0,
    "physical_damage": 160,
    "magic_damage": 0,
    "physical_resist": 0,
    "magic_resist": 0,
    "speed": 110,
    "dodge": 0,
    "stamina": 100,
    "stamina_regeneration": 7.5,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 73.75
  },
  "Bishop_Archer": {
    "health": 324,
    "health_regeneration": 0,
    "physical_damage": 72,
    "magic_damage": 72,
    "physical_resist": 0,
    "magic_resist": 0,
    "speed": 115,
    "dodge": 0,
    "stamina": 50,
    "stamina_regeneration": 3.75,
    "mana": 50,
    "mana_regeneration": 3.75,
    "power": 69.05
  },
  "Bishop_Mage": {
    "health": 291.6,
    "health_regeneration": 0,
    "physical_damage": 0,
    "magic_damage": 130,
    "physical_resist": 0,
    "magic_resist": 0,
    "speed": 112.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 100,
    "mana_regeneration": 7.5,
    "power": 64.16
  },
  "Rook_Warrior": {
    "health": 500,
    "health_regeneration": 0,
    "physical_damage": 140,
    "magic_damage": 0,
    "physical_resist": 0,
    "magic_resist": 0,
    "speed": 105,
    "dodge": 0,
    "stamina": 100,
    "stamina_regeneration": 10,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 85.5
  },
  "Rook_Archer": {
    "health": 450,
    "health_regeneration": 0,
    "physical_damage": 63,
    "magic_damage": 63,
    "physical_resist": 0,
    "magic_resist": 0,
    "speed": 110,
    "dodge": 0,
    "stamina": 50,
    "stamina_regeneration": 5,
    "mana": 50,
    "mana_regeneration": 5,
    "power": 79.6
  },
  "Rook_Mage": {
    "health": 405,
    "health_regeneration": 0,
    "physical_damage": 0,
    "magic_damage": 113,
    "physical_resist": 0,
    "magic_resist": 0,
    "speed": 107.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 100,
    "mana_regeneration": 10,
    "power": 73.55
  },
  "Queen_Warrior": {
    "health": 460,
    "health_regeneration": 5,
    "physical_damage": 180,
    "magic_damage": 0,
    "physical_resist": 0,
    "magic_resist": 0,
    "speed": 112.5,
    "dodge": 0.05,
    "stamina": 150,
    "stamina_regeneration": 12.5,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 96.6
  },
  "Queen_Archer": {
    "health": 414,
    "health_regeneration": 5,
    "physical_damage": 81,
    "magic_damage": 81,
    "physical_resist": 0,
    "magic_resist": 0,
    "speed": 117.5,
    "dodge": 0.025,
    "stamina": 75,
    "stamina_regeneration": 6.25,
    "mana": 75,
    "mana_regeneration": 6.25,
    "power": 88.2525
  },
  "Queen_Mage": {
    "health": 372.6,
    "health_regeneration": 5,
    "physical_damage": 0,
    "magic_damage": 146,
    "physical_resist": 0,
    "magic_resist": 0,
    "speed": 115,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 150,
    "mana_regeneration": 12.5,
    "power": 80.11
  },
  "King_Warrior": {
    "health": 420,
    "health_regeneration": 15,
    "physical_damage": 160,
    "magic_damage": 0,
    "physical_resist": 0,
    "magic_resist": 0,
    "speed": 105,
    "dodge": 0,
    "stamina": 200,
    "stamina_regeneration": 15,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 91.5
  },
  "King_Archer": {
    "health": 378,
    "health_regeneration": 15,
    "physical_damage": 72,
    "magic_damage": 72,
    "physical_resist": 0,
    "magic_resist": 0,
    "speed": 110,
    "dodge": 0,
    "stamina": 100,
    "stamina_regeneration": 7.5,
    "mana": 100,
    "mana_regeneration": 7.5,
    "power": 86.2
  },
  "King_Mage": {
    "health": 340.2,
    "health_regeneration": 15,
    "physical_damage": 0,
    "magic_damage": 130,
    "physical_resist": 0,
    "magic_resist": 0,
    "speed": 107.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 200,
    "mana_regeneration": 15,
    "power": 80.77
  }
};

// Те же статы по ВСЕМ уровням книги баланса. Ключ: `${type}_${rank}_${level}`.
// 🔴 Нужна там, где уровень фигуры бывает НЕ третьим (NFT-воины: древние герои — 5 уровня).
export const UNIT_STATS_BY_LEVEL = {
  "Pawn_Warrior_1": {
    "health": 100,
    "health_regeneration": 0,
    "physical_damage": 100,
    "magic_damage": 0,
    "physical_resist": 0,
    "magic_resist": 0,
    "speed": 100,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 30
  },
  "Pawn_Warrior_2": {
    "health": 200,
    "health_regeneration": 0,
    "physical_damage": 110,
    "magic_damage": 0,
    "physical_resist": 0,
    "magic_resist": 0,
    "speed": 100,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 41
  },
  "Pawn_Warrior_3": {
    "health": 300,
    "health_regeneration": 0,
    "physical_damage": 120,
    "magic_damage": 0,
    "physical_resist": 0,
    "magic_resist": 0,
    "speed": 100,
    "dodge": 0,
    "stamina": 50,
    "stamina_regeneration": 5,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 57.5
  },
  "Pawn_Warrior_4": {
    "health": 400,
    "health_regeneration": 0,
    "physical_damage": 130,
    "magic_damage": 0,
    "physical_resist": 0.05,
    "magic_resist": 0,
    "speed": 100,
    "dodge": 0,
    "stamina": 50,
    "stamina_regeneration": 5,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 71.925
  },
  "Pawn_Warrior_5": {
    "health": 500,
    "health_regeneration": 0,
    "physical_damage": 140,
    "magic_damage": 0,
    "physical_resist": 0.05,
    "magic_resist": 0,
    "speed": 100,
    "dodge": 0,
    "stamina": 50,
    "stamina_regeneration": 5,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 83.475
  },
  "Pawn_Warrior_6": {
    "health": 600,
    "health_regeneration": 0,
    "physical_damage": 150,
    "magic_damage": 0,
    "physical_resist": 0.05,
    "magic_resist": 0,
    "speed": 100,
    "dodge": 0,
    "stamina": 50,
    "stamina_regeneration": 5,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 95.025
  },
  "Pawn_Warrior_7": {
    "health": 700,
    "health_regeneration": 5,
    "physical_damage": 160,
    "magic_damage": 0,
    "physical_resist": 0.075,
    "magic_resist": 0,
    "speed": 100,
    "dodge": 0.025,
    "stamina": 100,
    "stamina_regeneration": 5,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 117.7
  },
  "Pawn_Warrior_8": {
    "health": 800,
    "health_regeneration": 5,
    "physical_damage": 170,
    "magic_damage": 0,
    "physical_resist": 0.075,
    "magic_resist": 0,
    "speed": 100,
    "dodge": 0.025,
    "stamina": 100,
    "stamina_regeneration": 5,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 129.8
  },
  "Pawn_Warrior_9": {
    "health": 900,
    "health_regeneration": 5,
    "physical_damage": 180,
    "magic_damage": 0,
    "physical_resist": 0.075,
    "magic_resist": 0,
    "speed": 100,
    "dodge": 0.025,
    "stamina": 100,
    "stamina_regeneration": 5,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 141.9
  },
  "Pawn_Warrior_10": {
    "health": 1000,
    "health_regeneration": 10,
    "physical_damage": 190,
    "magic_damage": 0,
    "physical_resist": 0.1,
    "magic_resist": 0,
    "speed": 100,
    "dodge": 0.05,
    "stamina": 150,
    "stamina_regeneration": 5,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 167.325
  },
  "Pawn_Warrior_11": {
    "health": 1100,
    "health_regeneration": 10,
    "physical_damage": 200,
    "magic_damage": 0,
    "physical_resist": 0.1,
    "magic_resist": 0,
    "speed": 100,
    "dodge": 0.05,
    "stamina": 150,
    "stamina_regeneration": 5,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 179.975
  },
  "Pawn_Warrior_12": {
    "health": 1200,
    "health_regeneration": 10,
    "physical_damage": 210,
    "magic_damage": 0,
    "physical_resist": 0.1,
    "magic_resist": 0,
    "speed": 100,
    "dodge": 0.05,
    "stamina": 150,
    "stamina_regeneration": 5,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 192.625
  },
  "Pawn_Warrior_13": {
    "health": 1300,
    "health_regeneration": 15,
    "physical_damage": 220,
    "magic_damage": 0,
    "physical_resist": 0.125,
    "magic_resist": 0,
    "speed": 100,
    "dodge": 0.075,
    "stamina": 200,
    "stamina_regeneration": 5,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 220.8
  },
  "Pawn_Warrior_14": {
    "health": 1400,
    "health_regeneration": 15,
    "physical_damage": 230,
    "magic_damage": 0,
    "physical_resist": 0.125,
    "magic_resist": 0,
    "speed": 100,
    "dodge": 0.075,
    "stamina": 200,
    "stamina_regeneration": 5,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 234
  },
  "Pawn_Warrior_15": {
    "health": 1500,
    "health_regeneration": 15,
    "physical_damage": 240,
    "magic_damage": 0,
    "physical_resist": 0.125,
    "magic_resist": 0,
    "speed": 100,
    "dodge": 0.075,
    "stamina": 200,
    "stamina_regeneration": 5,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 247.2
  },
  "Pawn_Archer_3": {
    "health": 270,
    "health_regeneration": 0,
    "physical_damage": 54,
    "magic_damage": 54,
    "physical_resist": 0,
    "magic_resist": 0,
    "speed": 105,
    "dodge": 0,
    "stamina": 25,
    "stamina_regeneration": 2.5,
    "mana": 25,
    "mana_regeneration": 2.5,
    "power": 53.8
  },
  "Pawn_Archer_4": {
    "health": 360,
    "health_regeneration": 0,
    "physical_damage": 59,
    "magic_damage": 59,
    "physical_resist": 0.025,
    "magic_resist": 0.025,
    "speed": 105,
    "dodge": 0,
    "stamina": 25,
    "stamina_regeneration": 2.5,
    "mana": 25,
    "mana_regeneration": 2.5,
    "power": 66.99
  },
  "Pawn_Archer_5": {
    "health": 450,
    "health_regeneration": 0,
    "physical_damage": 63,
    "magic_damage": 63,
    "physical_resist": 0.025,
    "magic_resist": 0.025,
    "speed": 105,
    "dodge": 0,
    "stamina": 25,
    "stamina_regeneration": 2.5,
    "mana": 25,
    "mana_regeneration": 2.5,
    "power": 77.28
  },
  "Pawn_Archer_6": {
    "health": 540,
    "health_regeneration": 0,
    "physical_damage": 68,
    "magic_damage": 68,
    "physical_resist": 0.025,
    "magic_resist": 0.025,
    "speed": 105,
    "dodge": 0,
    "stamina": 25,
    "stamina_regeneration": 2.5,
    "mana": 25,
    "mana_regeneration": 2.5,
    "power": 87.78
  },
  "Pawn_Archer_7": {
    "health": 630,
    "health_regeneration": 5,
    "physical_damage": 72,
    "magic_damage": 72,
    "physical_resist": 0.0375,
    "magic_resist": 0.0375,
    "speed": 105,
    "dodge": 0,
    "stamina": 50,
    "stamina_regeneration": 2.5,
    "mana": 50,
    "mana_regeneration": 2.5,
    "power": 106.3175
  },
  "Pawn_Archer_8": {
    "health": 720,
    "health_regeneration": 5,
    "physical_damage": 77,
    "magic_damage": 77,
    "physical_resist": 0.0375,
    "magic_resist": 0.0375,
    "speed": 105,
    "dodge": 0,
    "stamina": 50,
    "stamina_regeneration": 2.5,
    "mana": 50,
    "mana_regeneration": 2.5,
    "power": 117.0675
  },
  "Pawn_Archer_9": {
    "health": 810,
    "health_regeneration": 5,
    "physical_damage": 81,
    "magic_damage": 81,
    "physical_resist": 0.0375,
    "magic_resist": 0.0375,
    "speed": 105,
    "dodge": 0,
    "stamina": 50,
    "stamina_regeneration": 2.5,
    "mana": 50,
    "mana_regeneration": 2.5,
    "power": 127.6025
  },
  "Pawn_Archer_10": {
    "health": 900,
    "health_regeneration": 10,
    "physical_damage": 86,
    "magic_damage": 86,
    "physical_resist": 0.05,
    "magic_resist": 0.05,
    "speed": 105,
    "dodge": 0.025,
    "stamina": 75,
    "stamina_regeneration": 2.5,
    "mana": 75,
    "mana_regeneration": 2.5,
    "power": 150.975
  },
  "Pawn_Archer_11": {
    "health": 990,
    "health_regeneration": 10,
    "physical_damage": 90,
    "magic_damage": 90,
    "physical_resist": 0.05,
    "magic_resist": 0.05,
    "speed": 105,
    "dodge": 0.025,
    "stamina": 75,
    "stamina_regeneration": 2.5,
    "mana": 75,
    "mana_regeneration": 2.5,
    "power": 162
  },
  "Pawn_Archer_12": {
    "health": 1080,
    "health_regeneration": 10,
    "physical_damage": 95,
    "magic_damage": 95,
    "physical_resist": 0.05,
    "magic_resist": 0.05,
    "speed": 105,
    "dodge": 0.025,
    "stamina": 75,
    "stamina_regeneration": 2.5,
    "mana": 75,
    "mana_regeneration": 2.5,
    "power": 173.25
  },
  "Pawn_Archer_13": {
    "health": 1170,
    "health_regeneration": 15,
    "physical_damage": 99,
    "magic_damage": 99,
    "physical_resist": 0.0625,
    "magic_resist": 0.0625,
    "speed": 105,
    "dodge": 0.05,
    "stamina": 100,
    "stamina_regeneration": 2.5,
    "mana": 100,
    "mana_regeneration": 2.5,
    "power": 198.9275
  },
  "Pawn_Archer_14": {
    "health": 1260,
    "health_regeneration": 15,
    "physical_damage": 104,
    "magic_damage": 104,
    "physical_resist": 0.0625,
    "magic_resist": 0.0625,
    "speed": 105,
    "dodge": 0.05,
    "stamina": 100,
    "stamina_regeneration": 2.5,
    "mana": 100,
    "mana_regeneration": 2.5,
    "power": 210.6775
  },
  "Pawn_Archer_15": {
    "health": 1350,
    "health_regeneration": 15,
    "physical_damage": 108,
    "magic_damage": 108,
    "physical_resist": 0.0625,
    "magic_resist": 0.0625,
    "speed": 105,
    "dodge": 0.05,
    "stamina": 100,
    "stamina_regeneration": 2.5,
    "mana": 100,
    "mana_regeneration": 2.5,
    "power": 222.1925
  },
  "Pawn_Mage_3": {
    "health": 243,
    "health_regeneration": 0,
    "physical_damage": 0,
    "magic_damage": 97,
    "physical_resist": 0,
    "magic_resist": 0,
    "speed": 102.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 50,
    "mana_regeneration": 5,
    "power": 49.75
  },
  "Pawn_Mage_4": {
    "health": 324,
    "health_regeneration": 0,
    "physical_damage": 0,
    "magic_damage": 105,
    "physical_resist": 0,
    "magic_resist": 0.05,
    "speed": 102.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 50,
    "mana_regeneration": 5,
    "power": 61.5825
  },
  "Pawn_Mage_5": {
    "health": 405,
    "health_regeneration": 0,
    "physical_damage": 0,
    "magic_damage": 113,
    "physical_resist": 0,
    "magic_resist": 0.05,
    "speed": 102.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 50,
    "mana_regeneration": 5,
    "power": 70.9275
  },
  "Pawn_Mage_6": {
    "health": 486,
    "health_regeneration": 0,
    "physical_damage": 0,
    "magic_damage": 122,
    "physical_resist": 0,
    "magic_resist": 0.05,
    "speed": 102.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 50,
    "mana_regeneration": 5,
    "power": 80.3775
  },
  "Pawn_Mage_7": {
    "health": 567,
    "health_regeneration": 5,
    "physical_damage": 0,
    "magic_damage": 130,
    "physical_resist": 0,
    "magic_resist": 0.075,
    "speed": 102.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 100,
    "mana_regeneration": 5,
    "power": 97.7713
  },
  "Pawn_Mage_8": {
    "health": 648,
    "health_regeneration": 5,
    "physical_damage": 0,
    "magic_damage": 138,
    "physical_resist": 0,
    "magic_resist": 0.075,
    "speed": 102.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 100,
    "mana_regeneration": 5,
    "power": 107.3387
  },
  "Pawn_Mage_9": {
    "health": 729,
    "health_regeneration": 5,
    "physical_damage": 0,
    "magic_damage": 146,
    "physical_resist": 0,
    "magic_resist": 0.075,
    "speed": 102.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 100,
    "mana_regeneration": 5,
    "power": 116.9062
  },
  "Pawn_Mage_10": {
    "health": 810,
    "health_regeneration": 10,
    "physical_damage": 0,
    "magic_damage": 154,
    "physical_resist": 0,
    "magic_resist": 0.1,
    "speed": 102.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 150,
    "mana_regeneration": 5,
    "power": 135.465
  },
  "Pawn_Mage_11": {
    "health": 891,
    "health_regeneration": 10,
    "physical_damage": 0,
    "magic_damage": 162,
    "physical_resist": 0,
    "magic_resist": 0.1,
    "speed": 102.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 150,
    "mana_regeneration": 5,
    "power": 145.255
  },
  "Pawn_Mage_12": {
    "health": 972,
    "health_regeneration": 10,
    "physical_damage": 0,
    "magic_damage": 170,
    "physical_resist": 0,
    "magic_resist": 0.1,
    "speed": 102.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 150,
    "mana_regeneration": 5,
    "power": 155.045
  },
  "Pawn_Mage_13": {
    "health": 1053,
    "health_regeneration": 15,
    "physical_damage": 0,
    "magic_damage": 178,
    "physical_resist": 0,
    "magic_resist": 0.125,
    "speed": 102.5,
    "dodge": 0.025,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 200,
    "mana_regeneration": 5,
    "power": 178.6525
  },
  "Pawn_Mage_14": {
    "health": 1134,
    "health_regeneration": 15,
    "physical_damage": 0,
    "magic_damage": 186,
    "physical_resist": 0,
    "magic_resist": 0.125,
    "speed": 102.5,
    "dodge": 0.025,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 200,
    "mana_regeneration": 5,
    "power": 188.8875
  },
  "Pawn_Mage_15": {
    "health": 1215,
    "health_regeneration": 15,
    "physical_damage": 0,
    "magic_damage": 194,
    "physical_resist": 0,
    "magic_resist": 0.125,
    "speed": 102.5,
    "dodge": 0.025,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 200,
    "mana_regeneration": 5,
    "power": 199.1225
  },
  "Knight_Warrior_1": {
    "health": 100,
    "health_regeneration": 0,
    "physical_damage": 100,
    "magic_damage": 0,
    "physical_resist": 0,
    "magic_resist": 0,
    "speed": 100,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 30
  },
  "Knight_Warrior_2": {
    "health": 200,
    "health_regeneration": 0,
    "physical_damage": 110,
    "magic_damage": 0,
    "physical_resist": 0,
    "magic_resist": 0,
    "speed": 112,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 42.2
  },
  "Knight_Warrior_3": {
    "health": 300,
    "health_regeneration": 0,
    "physical_damage": 120,
    "magic_damage": 0,
    "physical_resist": 0,
    "magic_resist": 0,
    "speed": 112,
    "dodge": 0,
    "stamina": 50,
    "stamina_regeneration": 7.5,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 58.95
  },
  "Knight_Warrior_4": {
    "health": 400,
    "health_regeneration": 0,
    "physical_damage": 130,
    "magic_damage": 0,
    "physical_resist": 0.05,
    "magic_resist": 0,
    "speed": 112,
    "dodge": 0,
    "stamina": 50,
    "stamina_regeneration": 7.5,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 73.4475
  },
  "Knight_Warrior_5": {
    "health": 500,
    "health_regeneration": 0,
    "physical_damage": 140,
    "magic_damage": 0,
    "physical_resist": 0.05,
    "magic_resist": 0,
    "speed": 112,
    "dodge": 0,
    "stamina": 50,
    "stamina_regeneration": 7.5,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 84.9975
  },
  "Knight_Warrior_6": {
    "health": 600,
    "health_regeneration": 0,
    "physical_damage": 150,
    "magic_damage": 0,
    "physical_resist": 0.05,
    "magic_resist": 0,
    "speed": 112,
    "dodge": 0,
    "stamina": 50,
    "stamina_regeneration": 7.5,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 96.5475
  },
  "Knight_Warrior_7": {
    "health": 700,
    "health_regeneration": 5,
    "physical_damage": 160,
    "magic_damage": 0,
    "physical_resist": 0.075,
    "magic_resist": 0,
    "speed": 112,
    "dodge": 0.025,
    "stamina": 100,
    "stamina_regeneration": 7.5,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 119.295
  },
  "Knight_Warrior_8": {
    "health": 800,
    "health_regeneration": 5,
    "physical_damage": 170,
    "magic_damage": 0,
    "physical_resist": 0.075,
    "magic_resist": 0,
    "speed": 112,
    "dodge": 0.025,
    "stamina": 100,
    "stamina_regeneration": 7.5,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 131.395
  },
  "Knight_Warrior_9": {
    "health": 900,
    "health_regeneration": 5,
    "physical_damage": 180,
    "magic_damage": 0,
    "physical_resist": 0.075,
    "magic_resist": 0,
    "speed": 112,
    "dodge": 0.025,
    "stamina": 100,
    "stamina_regeneration": 7.5,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 143.495
  },
  "Knight_Warrior_10": {
    "health": 1000,
    "health_regeneration": 10,
    "physical_damage": 190,
    "magic_damage": 0,
    "physical_resist": 0.1,
    "magic_resist": 0,
    "speed": 112,
    "dodge": 0.05,
    "stamina": 150,
    "stamina_regeneration": 7.5,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 168.9925
  },
  "Knight_Warrior_11": {
    "health": 1100,
    "health_regeneration": 10,
    "physical_damage": 200,
    "magic_damage": 0,
    "physical_resist": 0.1,
    "magic_resist": 0,
    "speed": 112,
    "dodge": 0.05,
    "stamina": 150,
    "stamina_regeneration": 7.5,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 181.6425
  },
  "Knight_Warrior_12": {
    "health": 1200,
    "health_regeneration": 10,
    "physical_damage": 210,
    "magic_damage": 0,
    "physical_resist": 0.1,
    "magic_resist": 0,
    "speed": 112,
    "dodge": 0.05,
    "stamina": 150,
    "stamina_regeneration": 7.5,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 194.2925
  },
  "Knight_Warrior_13": {
    "health": 1300,
    "health_regeneration": 15,
    "physical_damage": 220,
    "magic_damage": 0,
    "physical_resist": 0.125,
    "magic_resist": 0,
    "speed": 112,
    "dodge": 0.075,
    "stamina": 200,
    "stamina_regeneration": 7.5,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 222.54
  },
  "Knight_Warrior_14": {
    "health": 1400,
    "health_regeneration": 15,
    "physical_damage": 230,
    "magic_damage": 0,
    "physical_resist": 0.125,
    "magic_resist": 0,
    "speed": 112,
    "dodge": 0.075,
    "stamina": 200,
    "stamina_regeneration": 7.5,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 235.74
  },
  "Knight_Warrior_15": {
    "health": 1500,
    "health_regeneration": 15,
    "physical_damage": 240,
    "magic_damage": 0,
    "physical_resist": 0.125,
    "magic_resist": 0,
    "speed": 112,
    "dodge": 0.075,
    "stamina": 200,
    "stamina_regeneration": 7.5,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 248.94
  },
  "Knight_Archer_3": {
    "health": 270,
    "health_regeneration": 0,
    "physical_damage": 54,
    "magic_damage": 54,
    "physical_resist": 0,
    "magic_resist": 0,
    "speed": 117,
    "dodge": 0,
    "stamina": 25,
    "stamina_regeneration": 3.75,
    "mana": 25,
    "mana_regeneration": 3.75,
    "power": 55.25
  },
  "Knight_Archer_4": {
    "health": 360,
    "health_regeneration": 0,
    "physical_damage": 59,
    "magic_damage": 59,
    "physical_resist": 0.025,
    "magic_resist": 0.025,
    "speed": 117,
    "dodge": 0,
    "stamina": 25,
    "stamina_regeneration": 3.75,
    "mana": 25,
    "mana_regeneration": 3.75,
    "power": 68.5125
  },
  "Knight_Archer_5": {
    "health": 450,
    "health_regeneration": 0,
    "physical_damage": 63,
    "magic_damage": 63,
    "physical_resist": 0.025,
    "magic_resist": 0.025,
    "speed": 117,
    "dodge": 0,
    "stamina": 25,
    "stamina_regeneration": 3.75,
    "mana": 25,
    "mana_regeneration": 3.75,
    "power": 78.8025
  },
  "Knight_Archer_6": {
    "health": 540,
    "health_regeneration": 0,
    "physical_damage": 68,
    "magic_damage": 68,
    "physical_resist": 0.025,
    "magic_resist": 0.025,
    "speed": 117,
    "dodge": 0,
    "stamina": 25,
    "stamina_regeneration": 3.75,
    "mana": 25,
    "mana_regeneration": 3.75,
    "power": 89.3025
  },
  "Knight_Archer_7": {
    "health": 630,
    "health_regeneration": 5,
    "physical_damage": 72,
    "magic_damage": 72,
    "physical_resist": 0.0375,
    "magic_resist": 0.0375,
    "speed": 117,
    "dodge": 0,
    "stamina": 50,
    "stamina_regeneration": 3.75,
    "mana": 50,
    "mana_regeneration": 3.75,
    "power": 107.8762
  },
  "Knight_Archer_8": {
    "health": 720,
    "health_regeneration": 5,
    "physical_damage": 77,
    "magic_damage": 77,
    "physical_resist": 0.0375,
    "magic_resist": 0.0375,
    "speed": 117,
    "dodge": 0,
    "stamina": 50,
    "stamina_regeneration": 3.75,
    "mana": 50,
    "mana_regeneration": 3.75,
    "power": 118.6262
  },
  "Knight_Archer_9": {
    "health": 810,
    "health_regeneration": 5,
    "physical_damage": 81,
    "magic_damage": 81,
    "physical_resist": 0.0375,
    "magic_resist": 0.0375,
    "speed": 117,
    "dodge": 0,
    "stamina": 50,
    "stamina_regeneration": 3.75,
    "mana": 50,
    "mana_regeneration": 3.75,
    "power": 129.1612
  },
  "Knight_Archer_10": {
    "health": 900,
    "health_regeneration": 10,
    "physical_damage": 86,
    "magic_damage": 86,
    "physical_resist": 0.05,
    "magic_resist": 0.05,
    "speed": 117,
    "dodge": 0.025,
    "stamina": 75,
    "stamina_regeneration": 3.75,
    "mana": 75,
    "mana_regeneration": 3.75,
    "power": 152.6063
  },
  "Knight_Archer_11": {
    "health": 990,
    "health_regeneration": 10,
    "physical_damage": 90,
    "magic_damage": 90,
    "physical_resist": 0.05,
    "magic_resist": 0.05,
    "speed": 117,
    "dodge": 0.025,
    "stamina": 75,
    "stamina_regeneration": 3.75,
    "mana": 75,
    "mana_regeneration": 3.75,
    "power": 163.6312
  },
  "Knight_Archer_12": {
    "health": 1080,
    "health_regeneration": 10,
    "physical_damage": 95,
    "magic_damage": 95,
    "physical_resist": 0.05,
    "magic_resist": 0.05,
    "speed": 117,
    "dodge": 0.025,
    "stamina": 75,
    "stamina_regeneration": 3.75,
    "mana": 75,
    "mana_regeneration": 3.75,
    "power": 174.8812
  },
  "Knight_Archer_13": {
    "health": 1170,
    "health_regeneration": 15,
    "physical_damage": 99,
    "magic_damage": 99,
    "physical_resist": 0.0625,
    "magic_resist": 0.0625,
    "speed": 117,
    "dodge": 0.05,
    "stamina": 100,
    "stamina_regeneration": 3.75,
    "mana": 100,
    "mana_regeneration": 3.75,
    "power": 200.6312
  },
  "Knight_Archer_14": {
    "health": 1260,
    "health_regeneration": 15,
    "physical_damage": 104,
    "magic_damage": 104,
    "physical_resist": 0.0625,
    "magic_resist": 0.0625,
    "speed": 117,
    "dodge": 0.05,
    "stamina": 100,
    "stamina_regeneration": 3.75,
    "mana": 100,
    "mana_regeneration": 3.75,
    "power": 212.3812
  },
  "Knight_Archer_15": {
    "health": 1350,
    "health_regeneration": 15,
    "physical_damage": 108,
    "magic_damage": 108,
    "physical_resist": 0.0625,
    "magic_resist": 0.0625,
    "speed": 117,
    "dodge": 0.05,
    "stamina": 100,
    "stamina_regeneration": 3.75,
    "mana": 100,
    "mana_regeneration": 3.75,
    "power": 223.8963
  },
  "Knight_Mage_3": {
    "health": 243,
    "health_regeneration": 0,
    "physical_damage": 0,
    "magic_damage": 97,
    "physical_resist": 0,
    "magic_resist": 0,
    "speed": 114.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 50,
    "mana_regeneration": 7.5,
    "power": 51.2
  },
  "Knight_Mage_4": {
    "health": 324,
    "health_regeneration": 0,
    "physical_damage": 0,
    "magic_damage": 105,
    "physical_resist": 0,
    "magic_resist": 0.05,
    "speed": 114.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 50,
    "mana_regeneration": 7.5,
    "power": 63.105
  },
  "Knight_Mage_5": {
    "health": 405,
    "health_regeneration": 0,
    "physical_damage": 0,
    "magic_damage": 113,
    "physical_resist": 0,
    "magic_resist": 0.05,
    "speed": 114.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 50,
    "mana_regeneration": 7.5,
    "power": 72.45
  },
  "Knight_Mage_6": {
    "health": 486,
    "health_regeneration": 0,
    "physical_damage": 0,
    "magic_damage": 122,
    "physical_resist": 0,
    "magic_resist": 0.05,
    "speed": 114.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 50,
    "mana_regeneration": 7.5,
    "power": 81.9
  },
  "Knight_Mage_7": {
    "health": 567,
    "health_regeneration": 5,
    "physical_damage": 0,
    "magic_damage": 130,
    "physical_resist": 0,
    "magic_resist": 0.075,
    "speed": 114.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 100,
    "mana_regeneration": 7.5,
    "power": 99.33
  },
  "Knight_Mage_8": {
    "health": 648,
    "health_regeneration": 5,
    "physical_damage": 0,
    "magic_damage": 138,
    "physical_resist": 0,
    "magic_resist": 0.075,
    "speed": 114.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 100,
    "mana_regeneration": 7.5,
    "power": 108.8975
  },
  "Knight_Mage_9": {
    "health": 729,
    "health_regeneration": 5,
    "physical_damage": 0,
    "magic_damage": 146,
    "physical_resist": 0,
    "magic_resist": 0.075,
    "speed": 114.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 100,
    "mana_regeneration": 7.5,
    "power": 118.465
  },
  "Knight_Mage_10": {
    "health": 810,
    "health_regeneration": 10,
    "physical_damage": 0,
    "magic_damage": 154,
    "physical_resist": 0,
    "magic_resist": 0.1,
    "speed": 114.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 150,
    "mana_regeneration": 7.5,
    "power": 137.06
  },
  "Knight_Mage_11": {
    "health": 891,
    "health_regeneration": 10,
    "physical_damage": 0,
    "magic_damage": 162,
    "physical_resist": 0,
    "magic_resist": 0.1,
    "speed": 114.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 150,
    "mana_regeneration": 7.5,
    "power": 146.85
  },
  "Knight_Mage_12": {
    "health": 972,
    "health_regeneration": 10,
    "physical_damage": 0,
    "magic_damage": 170,
    "physical_resist": 0,
    "magic_resist": 0.1,
    "speed": 114.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 150,
    "mana_regeneration": 7.5,
    "power": 156.64
  },
  "Knight_Mage_13": {
    "health": 1053,
    "health_regeneration": 15,
    "physical_damage": 0,
    "magic_damage": 178,
    "physical_resist": 0,
    "magic_resist": 0.125,
    "speed": 114.5,
    "dodge": 0.025,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 200,
    "mana_regeneration": 7.5,
    "power": 180.32
  },
  "Knight_Mage_14": {
    "health": 1134,
    "health_regeneration": 15,
    "physical_damage": 0,
    "magic_damage": 186,
    "physical_resist": 0,
    "magic_resist": 0.125,
    "speed": 114.5,
    "dodge": 0.025,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 200,
    "mana_regeneration": 7.5,
    "power": 190.555
  },
  "Knight_Mage_15": {
    "health": 1215,
    "health_regeneration": 15,
    "physical_damage": 0,
    "magic_damage": 194,
    "physical_resist": 0,
    "magic_resist": 0.125,
    "speed": 114.5,
    "dodge": 0.025,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 200,
    "mana_regeneration": 7.5,
    "power": 200.79
  },
  "Bishop_Warrior_1": {
    "health": 100,
    "health_regeneration": 0,
    "physical_damage": 100,
    "magic_damage": 0,
    "physical_resist": 0,
    "magic_resist": 0,
    "speed": 100,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 30
  },
  "Bishop_Warrior_2": {
    "health": 230,
    "health_regeneration": 0,
    "physical_damage": 130,
    "magic_damage": 0,
    "physical_resist": 0,
    "magic_resist": 0,
    "speed": 110,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 47
  },
  "Bishop_Warrior_3": {
    "health": 360,
    "health_regeneration": 0,
    "physical_damage": 160,
    "magic_damage": 0,
    "physical_resist": 0,
    "magic_resist": 0,
    "speed": 110,
    "dodge": 0,
    "stamina": 100,
    "stamina_regeneration": 7.5,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 73.75
  },
  "Bishop_Warrior_4": {
    "health": 490,
    "health_regeneration": 0,
    "physical_damage": 190,
    "magic_damage": 0,
    "physical_resist": 0.05,
    "magic_resist": 0,
    "speed": 110,
    "dodge": 0,
    "stamina": 100,
    "stamina_regeneration": 7.5,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 94.2375
  },
  "Bishop_Warrior_5": {
    "health": 620,
    "health_regeneration": 0,
    "physical_damage": 220,
    "magic_damage": 0,
    "physical_resist": 0.05,
    "magic_resist": 0,
    "speed": 110,
    "dodge": 0,
    "stamina": 100,
    "stamina_regeneration": 7.5,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 111.0375
  },
  "Bishop_Warrior_6": {
    "health": 750,
    "health_regeneration": 0,
    "physical_damage": 250,
    "magic_damage": 0,
    "physical_resist": 0.05,
    "magic_resist": 0,
    "speed": 110,
    "dodge": 0,
    "stamina": 100,
    "stamina_regeneration": 7.5,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 127.8375
  },
  "Bishop_Warrior_7": {
    "health": 880,
    "health_regeneration": 5,
    "physical_damage": 280,
    "magic_damage": 0,
    "physical_resist": 0.075,
    "magic_resist": 0,
    "speed": 110,
    "dodge": 0.025,
    "stamina": 200,
    "stamina_regeneration": 7.5,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 163.075
  },
  "Bishop_Warrior_8": {
    "health": 1010,
    "health_regeneration": 5,
    "physical_damage": 310,
    "magic_damage": 0,
    "physical_resist": 0.075,
    "magic_resist": 0,
    "speed": 110,
    "dodge": 0.025,
    "stamina": 200,
    "stamina_regeneration": 7.5,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 180.675
  },
  "Bishop_Warrior_9": {
    "health": 1140,
    "health_regeneration": 5,
    "physical_damage": 340,
    "magic_damage": 0,
    "physical_resist": 0.075,
    "magic_resist": 0,
    "speed": 110,
    "dodge": 0.025,
    "stamina": 200,
    "stamina_regeneration": 7.5,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 198.275
  },
  "Bishop_Warrior_10": {
    "health": 1270,
    "health_regeneration": 10,
    "physical_damage": 370,
    "magic_damage": 0,
    "physical_resist": 0.1,
    "magic_resist": 0,
    "speed": 110,
    "dodge": 0.05,
    "stamina": 300,
    "stamina_regeneration": 7.5,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 237.7625
  },
  "Bishop_Warrior_11": {
    "health": 1400,
    "health_regeneration": 10,
    "physical_damage": 400,
    "magic_damage": 0,
    "physical_resist": 0.1,
    "magic_resist": 0,
    "speed": 110,
    "dodge": 0.05,
    "stamina": 300,
    "stamina_regeneration": 7.5,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 256.1625
  },
  "Bishop_Warrior_12": {
    "health": 1530,
    "health_regeneration": 10,
    "physical_damage": 430,
    "magic_damage": 0,
    "physical_resist": 0.1,
    "magic_resist": 0,
    "speed": 110,
    "dodge": 0.05,
    "stamina": 300,
    "stamina_regeneration": 7.5,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 274.5625
  },
  "Bishop_Warrior_13": {
    "health": 1660,
    "health_regeneration": 15,
    "physical_damage": 460,
    "magic_damage": 0,
    "physical_resist": 0.125,
    "magic_resist": 0,
    "speed": 110,
    "dodge": 0.075,
    "stamina": 400,
    "stamina_regeneration": 7.5,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 318.3
  },
  "Bishop_Warrior_14": {
    "health": 1790,
    "health_regeneration": 15,
    "physical_damage": 490,
    "magic_damage": 0,
    "physical_resist": 0.125,
    "magic_resist": 0,
    "speed": 110,
    "dodge": 0.075,
    "stamina": 400,
    "stamina_regeneration": 7.5,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 337.5
  },
  "Bishop_Warrior_15": {
    "health": 1920,
    "health_regeneration": 15,
    "physical_damage": 520,
    "magic_damage": 0,
    "physical_resist": 0.125,
    "magic_resist": 0,
    "speed": 110,
    "dodge": 0.075,
    "stamina": 400,
    "stamina_regeneration": 7.5,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 356.7
  },
  "Bishop_Archer_3": {
    "health": 324,
    "health_regeneration": 0,
    "physical_damage": 72,
    "magic_damage": 72,
    "physical_resist": 0,
    "magic_resist": 0,
    "speed": 115,
    "dodge": 0,
    "stamina": 50,
    "stamina_regeneration": 3.75,
    "mana": 50,
    "mana_regeneration": 3.75,
    "power": 69.05
  },
  "Bishop_Archer_4": {
    "health": 441,
    "health_regeneration": 0,
    "physical_damage": 86,
    "magic_damage": 86,
    "physical_resist": 0.025,
    "magic_resist": 0.025,
    "speed": 115,
    "dodge": 0,
    "stamina": 50,
    "stamina_regeneration": 3.75,
    "mana": 50,
    "mana_regeneration": 3.75,
    "power": 87.7275
  },
  "Bishop_Archer_5": {
    "health": 558,
    "health_regeneration": 0,
    "physical_damage": 99,
    "magic_damage": 99,
    "physical_resist": 0.025,
    "magic_resist": 0.025,
    "speed": 115,
    "dodge": 0,
    "stamina": 50,
    "stamina_regeneration": 3.75,
    "mana": 50,
    "mana_regeneration": 3.75,
    "power": 102.7425
  },
  "Bishop_Archer_6": {
    "health": 675,
    "health_regeneration": 0,
    "physical_damage": 113,
    "magic_damage": 113,
    "physical_resist": 0.025,
    "magic_resist": 0.025,
    "speed": 115,
    "dodge": 0,
    "stamina": 50,
    "stamina_regeneration": 3.75,
    "mana": 50,
    "mana_regeneration": 3.75,
    "power": 117.9675
  },
  "Bishop_Archer_7": {
    "health": 792,
    "health_regeneration": 5,
    "physical_damage": 126,
    "magic_damage": 126,
    "physical_resist": 0.0375,
    "magic_resist": 0.0375,
    "speed": 115,
    "dodge": 0,
    "stamina": 100,
    "stamina_regeneration": 3.75,
    "mana": 100,
    "mana_regeneration": 3.75,
    "power": 147.4363
  },
  "Bishop_Archer_8": {
    "health": 909,
    "health_regeneration": 5,
    "physical_damage": 140,
    "magic_damage": 140,
    "physical_resist": 0.0375,
    "magic_resist": 0.0375,
    "speed": 115,
    "dodge": 0,
    "stamina": 100,
    "stamina_regeneration": 3.75,
    "mana": 100,
    "mana_regeneration": 3.75,
    "power": 163.0238
  },
  "Bishop_Archer_9": {
    "health": 1026,
    "health_regeneration": 5,
    "physical_damage": 153,
    "magic_damage": 153,
    "physical_resist": 0.0375,
    "magic_resist": 0.0375,
    "speed": 115,
    "dodge": 0,
    "stamina": 100,
    "stamina_regeneration": 3.75,
    "mana": 100,
    "mana_regeneration": 3.75,
    "power": 178.3962
  },
  "Bishop_Archer_10": {
    "health": 1143,
    "health_regeneration": 10,
    "physical_damage": 167,
    "magic_damage": 167,
    "physical_resist": 0.05,
    "magic_resist": 0.05,
    "speed": 115,
    "dodge": 0.025,
    "stamina": 150,
    "stamina_regeneration": 3.75,
    "mana": 150,
    "mana_regeneration": 3.75,
    "power": 214.8187
  },
  "Bishop_Archer_11": {
    "health": 1260,
    "health_regeneration": 10,
    "physical_damage": 180,
    "magic_damage": 180,
    "physical_resist": 0.05,
    "magic_resist": 0.05,
    "speed": 115,
    "dodge": 0.025,
    "stamina": 150,
    "stamina_regeneration": 3.75,
    "mana": 150,
    "mana_regeneration": 3.75,
    "power": 230.9062
  },
  "Bishop_Archer_12": {
    "health": 1377,
    "health_regeneration": 10,
    "physical_damage": 194,
    "magic_damage": 194,
    "physical_resist": 0.05,
    "magic_resist": 0.05,
    "speed": 115,
    "dodge": 0.025,
    "stamina": 150,
    "stamina_regeneration": 3.75,
    "mana": 150,
    "mana_regeneration": 3.75,
    "power": 247.2188
  },
  "Bishop_Archer_13": {
    "health": 1494,
    "health_regeneration": 15,
    "physical_damage": 207,
    "magic_damage": 207,
    "physical_resist": 0.0625,
    "magic_resist": 0.0625,
    "speed": 115,
    "dodge": 0.05,
    "stamina": 200,
    "stamina_regeneration": 3.75,
    "mana": 200,
    "mana_regeneration": 3.75,
    "power": 287.3462
  },
  "Bishop_Archer_14": {
    "health": 1611,
    "health_regeneration": 15,
    "physical_damage": 221,
    "magic_damage": 221,
    "physical_resist": 0.0625,
    "magic_resist": 0.0625,
    "speed": 115,
    "dodge": 0.05,
    "stamina": 200,
    "stamina_regeneration": 3.75,
    "mana": 200,
    "mana_regeneration": 3.75,
    "power": 304.3838
  },
  "Bishop_Archer_15": {
    "health": 1728,
    "health_regeneration": 15,
    "physical_damage": 234,
    "magic_damage": 234,
    "physical_resist": 0.0625,
    "magic_resist": 0.0625,
    "speed": 115,
    "dodge": 0.05,
    "stamina": 200,
    "stamina_regeneration": 3.75,
    "mana": 200,
    "mana_regeneration": 3.75,
    "power": 321.1863
  },
  "Bishop_Mage_3": {
    "health": 291.6,
    "health_regeneration": 0,
    "physical_damage": 0,
    "magic_damage": 130,
    "physical_resist": 0,
    "magic_resist": 0,
    "speed": 112.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 100,
    "mana_regeneration": 7.5,
    "power": 64.16
  },
  "Bishop_Mage_4": {
    "health": 396.9,
    "health_regeneration": 0,
    "physical_damage": 0,
    "magic_damage": 154,
    "physical_resist": 0,
    "magic_resist": 0.05,
    "speed": 112.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 100,
    "mana_regeneration": 7.5,
    "power": 80.9445
  },
  "Bishop_Mage_5": {
    "health": 502.2,
    "health_regeneration": 0,
    "physical_damage": 0,
    "magic_damage": 178,
    "physical_resist": 0,
    "magic_resist": 0.05,
    "speed": 112.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 100,
    "mana_regeneration": 7.5,
    "power": 94.521
  },
  "Bishop_Mage_6": {
    "health": 607.5,
    "health_regeneration": 0,
    "physical_damage": 0,
    "magic_damage": 203,
    "physical_resist": 0,
    "magic_resist": 0.05,
    "speed": 112.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 100,
    "mana_regeneration": 7.5,
    "power": 108.2025
  },
  "Bishop_Mage_7": {
    "health": 712.8,
    "health_regeneration": 5,
    "physical_damage": 0,
    "magic_damage": 227,
    "physical_resist": 0,
    "magic_resist": 0.075,
    "speed": 112.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 200,
    "mana_regeneration": 7.5,
    "power": 135.966
  },
  "Bishop_Mage_8": {
    "health": 818.1,
    "health_regeneration": 5,
    "physical_damage": 0,
    "magic_damage": 251,
    "physical_resist": 0,
    "magic_resist": 0.075,
    "speed": 112.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 200,
    "mana_regeneration": 7.5,
    "power": 149.8657
  },
  "Bishop_Mage_9": {
    "health": 923.4,
    "health_regeneration": 5,
    "physical_damage": 0,
    "magic_damage": 275,
    "physical_resist": 0,
    "magic_resist": 0.075,
    "speed": 112.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 200,
    "mana_regeneration": 7.5,
    "power": 163.7655
  },
  "Bishop_Mage_10": {
    "health": 1028.7,
    "health_regeneration": 10,
    "physical_damage": 0,
    "magic_damage": 300,
    "physical_resist": 0,
    "magic_resist": 0.1,
    "speed": 112.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 300,
    "mana_regeneration": 7.5,
    "power": 193.457
  },
  "Bishop_Mage_11": {
    "health": 1134,
    "health_regeneration": 10,
    "physical_damage": 0,
    "magic_damage": 324,
    "physical_resist": 0,
    "magic_resist": 0.1,
    "speed": 112.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 300,
    "mana_regeneration": 7.5,
    "power": 207.68
  },
  "Bishop_Mage_12": {
    "health": 1239.3,
    "health_regeneration": 10,
    "physical_damage": 0,
    "magic_damage": 348,
    "physical_resist": 0,
    "magic_resist": 0.1,
    "speed": 112.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 300,
    "mana_regeneration": 7.5,
    "power": 221.903
  },
  "Bishop_Mage_13": {
    "health": 1344.6,
    "health_regeneration": 15,
    "physical_damage": 0,
    "magic_damage": 373,
    "physical_resist": 0,
    "magic_resist": 0.125,
    "speed": 112.5,
    "dodge": 0.025,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 400,
    "mana_regeneration": 7.5,
    "power": 259.049
  },
  "Bishop_Mage_14": {
    "health": 1449.9,
    "health_regeneration": 15,
    "physical_damage": 0,
    "magic_damage": 397,
    "physical_resist": 0,
    "magic_resist": 0.125,
    "speed": 112.5,
    "dodge": 0.025,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 400,
    "mana_regeneration": 7.5,
    "power": 273.9185
  },
  "Bishop_Mage_15": {
    "health": 1555.2,
    "health_regeneration": 15,
    "physical_damage": 0,
    "magic_damage": 421,
    "physical_resist": 0,
    "magic_resist": 0.125,
    "speed": 112.5,
    "dodge": 0.025,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 400,
    "mana_regeneration": 7.5,
    "power": 288.788
  },
  "Rook_Warrior_1": {
    "health": 100,
    "health_regeneration": 0,
    "physical_damage": 100,
    "magic_damage": 0,
    "physical_resist": 0,
    "magic_resist": 0,
    "speed": 100,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 30
  },
  "Rook_Warrior_2": {
    "health": 300,
    "health_regeneration": 0,
    "physical_damage": 120,
    "magic_damage": 0,
    "physical_resist": 0,
    "magic_resist": 0,
    "speed": 105,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 52.5
  },
  "Rook_Warrior_3": {
    "health": 500,
    "health_regeneration": 0,
    "physical_damage": 140,
    "magic_damage": 0,
    "physical_resist": 0,
    "magic_resist": 0,
    "speed": 105,
    "dodge": 0,
    "stamina": 100,
    "stamina_regeneration": 10,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 85.5
  },
  "Rook_Warrior_4": {
    "health": 700,
    "health_regeneration": 0,
    "physical_damage": 160,
    "magic_damage": 0,
    "physical_resist": 0.05,
    "magic_resist": 0,
    "speed": 105,
    "dodge": 0,
    "stamina": 100,
    "stamina_regeneration": 10,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 112.875
  },
  "Rook_Warrior_5": {
    "health": 900,
    "health_regeneration": 0,
    "physical_damage": 180,
    "magic_damage": 0,
    "physical_resist": 0.05,
    "magic_resist": 0,
    "speed": 105,
    "dodge": 0,
    "stamina": 100,
    "stamina_regeneration": 10,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 135.975
  },
  "Rook_Warrior_6": {
    "health": 1100,
    "health_regeneration": 0,
    "physical_damage": 200,
    "magic_damage": 0,
    "physical_resist": 0.05,
    "magic_resist": 0,
    "speed": 105,
    "dodge": 0,
    "stamina": 100,
    "stamina_regeneration": 10,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 159.075
  },
  "Rook_Warrior_7": {
    "health": 1300,
    "health_regeneration": 5,
    "physical_damage": 220,
    "magic_damage": 0,
    "physical_resist": 0.075,
    "magic_resist": 0,
    "speed": 105,
    "dodge": 0.025,
    "stamina": 200,
    "stamina_regeneration": 10,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 202.4
  },
  "Rook_Warrior_8": {
    "health": 1500,
    "health_regeneration": 5,
    "physical_damage": 240,
    "magic_damage": 0,
    "physical_resist": 0.075,
    "magic_resist": 0,
    "speed": 105,
    "dodge": 0.025,
    "stamina": 200,
    "stamina_regeneration": 10,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 226.6
  },
  "Rook_Warrior_9": {
    "health": 1700,
    "health_regeneration": 5,
    "physical_damage": 260,
    "magic_damage": 0,
    "physical_resist": 0.075,
    "magic_resist": 0,
    "speed": 105,
    "dodge": 0.025,
    "stamina": 200,
    "stamina_regeneration": 10,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 250.8
  },
  "Rook_Warrior_10": {
    "health": 1900,
    "health_regeneration": 10,
    "physical_damage": 280,
    "magic_damage": 0,
    "physical_resist": 0.1,
    "magic_resist": 0,
    "speed": 105,
    "dodge": 0.05,
    "stamina": 300,
    "stamina_regeneration": 10,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 299.575
  },
  "Rook_Warrior_11": {
    "health": 2100,
    "health_regeneration": 10,
    "physical_damage": 300,
    "magic_damage": 0,
    "physical_resist": 0.1,
    "magic_resist": 0,
    "speed": 105,
    "dodge": 0.05,
    "stamina": 300,
    "stamina_regeneration": 10,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 324.875
  },
  "Rook_Warrior_12": {
    "health": 2300,
    "health_regeneration": 10,
    "physical_damage": 320,
    "magic_damage": 0,
    "physical_resist": 0.1,
    "magic_resist": 0,
    "speed": 105,
    "dodge": 0.05,
    "stamina": 300,
    "stamina_regeneration": 10,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 350.175
  },
  "Rook_Warrior_13": {
    "health": 2500,
    "health_regeneration": 15,
    "physical_damage": 340,
    "magic_damage": 0,
    "physical_resist": 0.125,
    "magic_resist": 0,
    "speed": 105,
    "dodge": 0.075,
    "stamina": 400,
    "stamina_regeneration": 10,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 404.4
  },
  "Rook_Warrior_14": {
    "health": 2700,
    "health_regeneration": 15,
    "physical_damage": 360,
    "magic_damage": 0,
    "physical_resist": 0.125,
    "magic_resist": 0,
    "speed": 105,
    "dodge": 0.075,
    "stamina": 400,
    "stamina_regeneration": 10,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 430.8
  },
  "Rook_Warrior_15": {
    "health": 2900,
    "health_regeneration": 15,
    "physical_damage": 380,
    "magic_damage": 0,
    "physical_resist": 0.125,
    "magic_resist": 0,
    "speed": 105,
    "dodge": 0.075,
    "stamina": 400,
    "stamina_regeneration": 10,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 457.2
  },
  "Rook_Archer_3": {
    "health": 450,
    "health_regeneration": 0,
    "physical_damage": 63,
    "magic_damage": 63,
    "physical_resist": 0,
    "magic_resist": 0,
    "speed": 110,
    "dodge": 0,
    "stamina": 50,
    "stamina_regeneration": 5,
    "mana": 50,
    "mana_regeneration": 5,
    "power": 79.6
  },
  "Rook_Archer_4": {
    "health": 630,
    "health_regeneration": 0,
    "physical_damage": 72,
    "magic_damage": 72,
    "physical_resist": 0.025,
    "magic_resist": 0.025,
    "speed": 110,
    "dodge": 0,
    "stamina": 50,
    "stamina_regeneration": 5,
    "mana": 50,
    "mana_regeneration": 5,
    "power": 104.37
  },
  "Rook_Archer_5": {
    "health": 810,
    "health_regeneration": 0,
    "physical_damage": 81,
    "magic_damage": 81,
    "physical_resist": 0.025,
    "magic_resist": 0.025,
    "speed": 110,
    "dodge": 0,
    "stamina": 50,
    "stamina_regeneration": 5,
    "mana": 50,
    "mana_regeneration": 5,
    "power": 125.16
  },
  "Rook_Archer_6": {
    "health": 990,
    "health_regeneration": 0,
    "physical_damage": 90,
    "magic_damage": 90,
    "physical_resist": 0.025,
    "magic_resist": 0.025,
    "speed": 110,
    "dodge": 0,
    "stamina": 50,
    "stamina_regeneration": 5,
    "mana": 50,
    "mana_regeneration": 5,
    "power": 145.95
  },
  "Rook_Archer_7": {
    "health": 1170,
    "health_regeneration": 5,
    "physical_damage": 99,
    "magic_damage": 99,
    "physical_resist": 0.0375,
    "magic_resist": 0.0375,
    "speed": 110,
    "dodge": 0,
    "stamina": 100,
    "stamina_regeneration": 5,
    "mana": 100,
    "mana_regeneration": 5,
    "power": 181.9975
  },
  "Rook_Archer_8": {
    "health": 1350,
    "health_regeneration": 5,
    "physical_damage": 108,
    "magic_damage": 108,
    "physical_resist": 0.0375,
    "magic_resist": 0.0375,
    "speed": 110,
    "dodge": 0,
    "stamina": 100,
    "stamina_regeneration": 5,
    "mana": 100,
    "mana_regeneration": 5,
    "power": 203.2825
  },
  "Rook_Archer_9": {
    "health": 1530,
    "health_regeneration": 5,
    "physical_damage": 117,
    "magic_damage": 117,
    "physical_resist": 0.0375,
    "magic_resist": 0.0375,
    "speed": 110,
    "dodge": 0,
    "stamina": 100,
    "stamina_regeneration": 5,
    "mana": 100,
    "mana_regeneration": 5,
    "power": 224.5675
  },
  "Rook_Archer_10": {
    "health": 1710,
    "health_regeneration": 10,
    "physical_damage": 126,
    "magic_damage": 126,
    "physical_resist": 0.05,
    "magic_resist": 0.05,
    "speed": 110,
    "dodge": 0.025,
    "stamina": 150,
    "stamina_regeneration": 5,
    "mana": 150,
    "mana_regeneration": 5,
    "power": 269.1
  },
  "Rook_Archer_11": {
    "health": 1890,
    "health_regeneration": 10,
    "physical_damage": 135,
    "magic_damage": 135,
    "physical_resist": 0.05,
    "magic_resist": 0.05,
    "speed": 110,
    "dodge": 0.025,
    "stamina": 150,
    "stamina_regeneration": 5,
    "mana": 150,
    "mana_regeneration": 5,
    "power": 291.375
  },
  "Rook_Archer_12": {
    "health": 2070,
    "health_regeneration": 10,
    "physical_damage": 144,
    "magic_damage": 144,
    "physical_resist": 0.05,
    "magic_resist": 0.05,
    "speed": 110,
    "dodge": 0.025,
    "stamina": 150,
    "stamina_regeneration": 5,
    "mana": 150,
    "mana_regeneration": 5,
    "power": 313.65
  },
  "Rook_Archer_13": {
    "health": 2250,
    "health_regeneration": 15,
    "physical_damage": 153,
    "magic_damage": 153,
    "physical_resist": 0.0625,
    "magic_resist": 0.0625,
    "speed": 110,
    "dodge": 0.05,
    "stamina": 200,
    "stamina_regeneration": 5,
    "mana": 200,
    "mana_regeneration": 5,
    "power": 363.1925
  },
  "Rook_Archer_14": {
    "health": 2430,
    "health_regeneration": 15,
    "physical_damage": 162,
    "magic_damage": 162,
    "physical_resist": 0.0625,
    "magic_resist": 0.0625,
    "speed": 110,
    "dodge": 0.05,
    "stamina": 200,
    "stamina_regeneration": 5,
    "mana": 200,
    "mana_regeneration": 5,
    "power": 386.4575
  },
  "Rook_Archer_15": {
    "health": 2610,
    "health_regeneration": 15,
    "physical_damage": 171,
    "magic_damage": 171,
    "physical_resist": 0.0625,
    "magic_resist": 0.0625,
    "speed": 110,
    "dodge": 0.05,
    "stamina": 200,
    "stamina_regeneration": 5,
    "mana": 200,
    "mana_regeneration": 5,
    "power": 409.7225
  },
  "Rook_Mage_3": {
    "health": 405,
    "health_regeneration": 0,
    "physical_damage": 0,
    "magic_damage": 113,
    "physical_resist": 0,
    "magic_resist": 0,
    "speed": 107.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 100,
    "mana_regeneration": 10,
    "power": 73.55
  },
  "Rook_Mage_4": {
    "health": 567,
    "health_regeneration": 0,
    "physical_damage": 0,
    "magic_damage": 130,
    "physical_resist": 0,
    "magic_resist": 0.05,
    "speed": 107.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 100,
    "mana_regeneration": 10,
    "power": 96.0225
  },
  "Rook_Mage_5": {
    "health": 729,
    "health_regeneration": 0,
    "physical_damage": 0,
    "magic_damage": 146,
    "physical_resist": 0,
    "magic_resist": 0.05,
    "speed": 107.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 100,
    "mana_regeneration": 10,
    "power": 114.7125
  },
  "Rook_Mage_6": {
    "health": 891,
    "health_regeneration": 0,
    "physical_damage": 0,
    "magic_damage": 162,
    "physical_resist": 0,
    "magic_resist": 0.05,
    "speed": 107.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 100,
    "mana_regeneration": 10,
    "power": 133.4025
  },
  "Rook_Mage_7": {
    "health": 1053,
    "health_regeneration": 5,
    "physical_damage": 0,
    "magic_damage": 178,
    "physical_resist": 0,
    "magic_resist": 0.075,
    "speed": 107.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 200,
    "mana_regeneration": 10,
    "power": 167.0012
  },
  "Rook_Mage_8": {
    "health": 1215,
    "health_regeneration": 5,
    "physical_damage": 0,
    "magic_damage": 194,
    "physical_resist": 0,
    "magic_resist": 0.075,
    "speed": 107.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 200,
    "mana_regeneration": 10,
    "power": 186.1363
  },
  "Rook_Mage_9": {
    "health": 1377,
    "health_regeneration": 5,
    "physical_damage": 0,
    "magic_damage": 211,
    "physical_resist": 0,
    "magic_resist": 0.075,
    "speed": 107.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 200,
    "mana_regeneration": 10,
    "power": 205.3788
  },
  "Rook_Mage_10": {
    "health": 1539,
    "health_regeneration": 10,
    "physical_damage": 0,
    "magic_damage": 227,
    "physical_resist": 0,
    "magic_resist": 0.1,
    "speed": 107.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 300,
    "mana_regeneration": 10,
    "power": 241.285
  },
  "Rook_Mage_11": {
    "health": 1701,
    "health_regeneration": 10,
    "physical_damage": 0,
    "magic_damage": 243,
    "physical_resist": 0,
    "magic_resist": 0.1,
    "speed": 107.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 300,
    "mana_regeneration": 10,
    "power": 260.865
  },
  "Rook_Mage_12": {
    "health": 1863,
    "health_regeneration": 10,
    "physical_damage": 0,
    "magic_damage": 259,
    "physical_resist": 0,
    "magic_resist": 0.1,
    "speed": 107.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 300,
    "mana_regeneration": 10,
    "power": 280.445
  },
  "Rook_Mage_13": {
    "health": 2025,
    "health_regeneration": 15,
    "physical_damage": 0,
    "magic_damage": 275,
    "physical_resist": 0,
    "magic_resist": 0.125,
    "speed": 107.5,
    "dodge": 0.025,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 400,
    "mana_regeneration": 10,
    "power": 325.7375
  },
  "Rook_Mage_14": {
    "health": 2187,
    "health_regeneration": 15,
    "physical_damage": 0,
    "magic_damage": 292,
    "physical_resist": 0,
    "magic_resist": 0.125,
    "speed": 107.5,
    "dodge": 0.025,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 400,
    "mana_regeneration": 10,
    "power": 346.3225
  },
  "Rook_Mage_15": {
    "health": 2349,
    "health_regeneration": 15,
    "physical_damage": 0,
    "magic_damage": 308,
    "physical_resist": 0,
    "magic_resist": 0.125,
    "speed": 107.5,
    "dodge": 0.025,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 400,
    "mana_regeneration": 10,
    "power": 366.7925
  },
  "Queen_Warrior_1": {
    "health": 100,
    "health_regeneration": 0,
    "physical_damage": 100,
    "magic_damage": 0,
    "physical_resist": 0,
    "magic_resist": 0,
    "speed": 100,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 30
  },
  "Queen_Warrior_2": {
    "health": 280,
    "health_regeneration": 0,
    "physical_damage": 140,
    "magic_damage": 0,
    "physical_resist": 0,
    "magic_resist": 0,
    "speed": 112.5,
    "dodge": 0.05,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 55.9125
  },
  "Queen_Warrior_3": {
    "health": 460,
    "health_regeneration": 5,
    "physical_damage": 180,
    "magic_damage": 0,
    "physical_resist": 0,
    "magic_resist": 0,
    "speed": 112.5,
    "dodge": 0.05,
    "stamina": 150,
    "stamina_regeneration": 12.5,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 96.6
  },
  "Queen_Warrior_4": {
    "health": 640,
    "health_regeneration": 5,
    "physical_damage": 220,
    "magic_damage": 0,
    "physical_resist": 0.05,
    "magic_resist": 0.025,
    "speed": 112.5,
    "dodge": 0.05,
    "stamina": 200,
    "stamina_regeneration": 12.5,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 133.875
  },
  "Queen_Warrior_5": {
    "health": 820,
    "health_regeneration": 5,
    "physical_damage": 260,
    "magic_damage": 0,
    "physical_resist": 0.05,
    "magic_resist": 0.025,
    "speed": 112.5,
    "dodge": 0.05,
    "stamina": 200,
    "stamina_regeneration": 12.5,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 158.625
  },
  "Queen_Warrior_6": {
    "health": 1000,
    "health_regeneration": 5,
    "physical_damage": 300,
    "magic_damage": 0,
    "physical_resist": 0.05,
    "magic_resist": 0.025,
    "speed": 112.5,
    "dodge": 0.05,
    "stamina": 200,
    "stamina_regeneration": 12.5,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 183.375
  },
  "Queen_Warrior_7": {
    "health": 1180,
    "health_regeneration": 10,
    "physical_damage": 340,
    "magic_damage": 0,
    "physical_resist": 0.075,
    "magic_resist": 0.0375,
    "speed": 112.5,
    "dodge": 0.075,
    "stamina": 400,
    "stamina_regeneration": 12.5,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 244.0312
  },
  "Queen_Warrior_8": {
    "health": 1360,
    "health_regeneration": 10,
    "physical_damage": 380,
    "magic_damage": 0,
    "physical_resist": 0.075,
    "magic_resist": 0.0375,
    "speed": 112.5,
    "dodge": 0.075,
    "stamina": 400,
    "stamina_regeneration": 12.5,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 270.1562
  },
  "Queen_Warrior_9": {
    "health": 1540,
    "health_regeneration": 10,
    "physical_damage": 420,
    "magic_damage": 0,
    "physical_resist": 0.075,
    "magic_resist": 0.0375,
    "speed": 112.5,
    "dodge": 0.075,
    "stamina": 400,
    "stamina_regeneration": 12.5,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 296.2812
  },
  "Queen_Warrior_10": {
    "health": 1720,
    "health_regeneration": 15,
    "physical_damage": 460,
    "magic_damage": 0,
    "physical_resist": 0.1,
    "magic_resist": 0.05,
    "speed": 112.5,
    "dodge": 0.1,
    "stamina": 600,
    "stamina_regeneration": 12.5,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 365
  },
  "Queen_Warrior_11": {
    "health": 1900,
    "health_regeneration": 15,
    "physical_damage": 500,
    "magic_damage": 0,
    "physical_resist": 0.1,
    "magic_resist": 0.05,
    "speed": 112.5,
    "dodge": 0.1,
    "stamina": 600,
    "stamina_regeneration": 12.5,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 392.5
  },
  "Queen_Warrior_12": {
    "health": 2080,
    "health_regeneration": 15,
    "physical_damage": 540,
    "magic_damage": 0,
    "physical_resist": 0.1,
    "magic_resist": 0.05,
    "speed": 112.5,
    "dodge": 0.1,
    "stamina": 600,
    "stamina_regeneration": 12.5,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 420
  },
  "Queen_Warrior_13": {
    "health": 2260,
    "health_regeneration": 20,
    "physical_damage": 580,
    "magic_damage": 0,
    "physical_resist": 0.125,
    "magic_resist": 0.0625,
    "speed": 112.5,
    "dodge": 0.125,
    "stamina": 800,
    "stamina_regeneration": 12.5,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 496.7812
  },
  "Queen_Warrior_14": {
    "health": 2440,
    "health_regeneration": 20,
    "physical_damage": 620,
    "magic_damage": 0,
    "physical_resist": 0.125,
    "magic_resist": 0.0625,
    "speed": 112.5,
    "dodge": 0.125,
    "stamina": 800,
    "stamina_regeneration": 12.5,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 525.6562
  },
  "Queen_Warrior_15": {
    "health": 2620,
    "health_regeneration": 20,
    "physical_damage": 660,
    "magic_damage": 0,
    "physical_resist": 0.125,
    "magic_resist": 0.0625,
    "speed": 112.5,
    "dodge": 0.125,
    "stamina": 800,
    "stamina_regeneration": 12.5,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 554.5312
  },
  "Queen_Archer_3": {
    "health": 414,
    "health_regeneration": 5,
    "physical_damage": 81,
    "magic_damage": 81,
    "physical_resist": 0,
    "magic_resist": 0,
    "speed": 117.5,
    "dodge": 0.025,
    "stamina": 75,
    "stamina_regeneration": 6.25,
    "mana": 75,
    "mana_regeneration": 6.25,
    "power": 88.2525
  },
  "Queen_Archer_4": {
    "health": 576,
    "health_regeneration": 5,
    "physical_damage": 99,
    "magic_damage": 99,
    "physical_resist": 0.0375,
    "magic_resist": 0.0375,
    "speed": 117.5,
    "dodge": 0.025,
    "stamina": 100,
    "stamina_regeneration": 6.25,
    "mana": 100,
    "mana_regeneration": 6.25,
    "power": 121.99
  },
  "Queen_Archer_5": {
    "health": 738,
    "health_regeneration": 5,
    "physical_damage": 117,
    "magic_damage": 117,
    "physical_resist": 0.0375,
    "magic_resist": 0.0375,
    "speed": 117.5,
    "dodge": 0.025,
    "stamina": 100,
    "stamina_regeneration": 6.25,
    "mana": 100,
    "mana_regeneration": 6.25,
    "power": 143.77
  },
  "Queen_Archer_6": {
    "health": 900,
    "health_regeneration": 5,
    "physical_damage": 135,
    "magic_damage": 135,
    "physical_resist": 0.0375,
    "magic_resist": 0.0375,
    "speed": 117.5,
    "dodge": 0.025,
    "stamina": 100,
    "stamina_regeneration": 6.25,
    "mana": 100,
    "mana_regeneration": 6.25,
    "power": 165.55
  },
  "Queen_Archer_7": {
    "health": 1062,
    "health_regeneration": 10,
    "physical_damage": 153,
    "magic_damage": 153,
    "physical_resist": 0.0563,
    "magic_resist": 0.0563,
    "speed": 117.5,
    "dodge": 0.05,
    "stamina": 200,
    "stamina_regeneration": 6.25,
    "mana": 200,
    "mana_regeneration": 6.25,
    "power": 221.8241
  },
  "Queen_Archer_8": {
    "health": 1224,
    "health_regeneration": 10,
    "physical_damage": 171,
    "magic_damage": 171,
    "physical_resist": 0.0563,
    "magic_resist": 0.0563,
    "speed": 117.5,
    "dodge": 0.05,
    "stamina": 200,
    "stamina_regeneration": 6.25,
    "mana": 200,
    "mana_regeneration": 6.25,
    "power": 244.8436
  },
  "Queen_Archer_9": {
    "health": 1386,
    "health_regeneration": 10,
    "physical_damage": 189,
    "magic_damage": 189,
    "physical_resist": 0.0563,
    "magic_resist": 0.0563,
    "speed": 117.5,
    "dodge": 0.05,
    "stamina": 200,
    "stamina_regeneration": 6.25,
    "mana": 200,
    "mana_regeneration": 6.25,
    "power": 267.863
  },
  "Queen_Archer_10": {
    "health": 1548,
    "health_regeneration": 15,
    "physical_damage": 207,
    "magic_damage": 207,
    "physical_resist": 0.075,
    "magic_resist": 0.075,
    "speed": 117.5,
    "dodge": 0.075,
    "stamina": 300,
    "stamina_regeneration": 6.25,
    "mana": 300,
    "mana_regeneration": 6.25,
    "power": 331.6075
  },
  "Queen_Archer_11": {
    "health": 1710,
    "health_regeneration": 15,
    "physical_damage": 225,
    "magic_damage": 225,
    "physical_resist": 0.075,
    "magic_resist": 0.075,
    "speed": 117.5,
    "dodge": 0.075,
    "stamina": 300,
    "stamina_regeneration": 6.25,
    "mana": 300,
    "mana_regeneration": 6.25,
    "power": 355.8625
  },
  "Queen_Archer_12": {
    "health": 1872,
    "health_regeneration": 15,
    "physical_damage": 243,
    "magic_damage": 243,
    "physical_resist": 0.075,
    "magic_resist": 0.075,
    "speed": 117.5,
    "dodge": 0.075,
    "stamina": 300,
    "stamina_regeneration": 6.25,
    "mana": 300,
    "mana_regeneration": 6.25,
    "power": 380.1175
  },
  "Queen_Archer_13": {
    "health": 2034,
    "health_regeneration": 20,
    "physical_damage": 261,
    "magic_damage": 261,
    "physical_resist": 0.0938,
    "magic_resist": 0.0938,
    "speed": 117.5,
    "dodge": 0.1,
    "stamina": 400,
    "stamina_regeneration": 6.25,
    "mana": 400,
    "mana_regeneration": 6.25,
    "power": 451.4326
  },
  "Queen_Archer_14": {
    "health": 2196,
    "health_regeneration": 20,
    "physical_damage": 279,
    "magic_damage": 279,
    "physical_resist": 0.0938,
    "magic_resist": 0.0938,
    "speed": 117.5,
    "dodge": 0.1,
    "stamina": 400,
    "stamina_regeneration": 6.25,
    "mana": 400,
    "mana_regeneration": 6.25,
    "power": 476.927
  },
  "Queen_Archer_15": {
    "health": 2358,
    "health_regeneration": 20,
    "physical_damage": 297,
    "magic_damage": 297,
    "physical_resist": 0.0938,
    "magic_resist": 0.0938,
    "speed": 117.5,
    "dodge": 0.1,
    "stamina": 400,
    "stamina_regeneration": 6.25,
    "mana": 400,
    "mana_regeneration": 6.25,
    "power": 502.4215
  },
  "Queen_Mage_3": {
    "health": 372.6,
    "health_regeneration": 5,
    "physical_damage": 0,
    "magic_damage": 146,
    "physical_resist": 0,
    "magic_resist": 0,
    "speed": 115,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 150,
    "mana_regeneration": 12.5,
    "power": 80.11
  },
  "Queen_Mage_4": {
    "health": 518.4,
    "health_regeneration": 5,
    "physical_damage": 0,
    "magic_damage": 178,
    "physical_resist": 0.025,
    "magic_resist": 0.05,
    "speed": 115,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 200,
    "mana_regeneration": 12.5,
    "power": 110.6068
  },
  "Queen_Mage_5": {
    "health": 664.2,
    "health_regeneration": 5,
    "physical_damage": 0,
    "magic_damage": 211,
    "physical_resist": 0.025,
    "magic_resist": 0.05,
    "speed": 115,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 200,
    "mana_regeneration": 12.5,
    "power": 129.8278
  },
  "Queen_Mage_6": {
    "health": 810,
    "health_regeneration": 5,
    "physical_damage": 0,
    "magic_damage": 243,
    "physical_resist": 0.025,
    "magic_resist": 0.05,
    "speed": 115,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 200,
    "mana_regeneration": 12.5,
    "power": 148.9413
  },
  "Queen_Mage_7": {
    "health": 955.8,
    "health_regeneration": 10,
    "physical_damage": 0,
    "magic_damage": 275,
    "physical_resist": 0.0375,
    "magic_resist": 0.075,
    "speed": 115,
    "dodge": 0.025,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 400,
    "mana_regeneration": 12.5,
    "power": 201.1441
  },
  "Queen_Mage_8": {
    "health": 1101.6,
    "health_regeneration": 10,
    "physical_damage": 0,
    "magic_damage": 308,
    "physical_resist": 0.0375,
    "magic_resist": 0.075,
    "speed": 115,
    "dodge": 0.025,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 400,
    "mana_regeneration": 12.5,
    "power": 221.4826
  },
  "Queen_Mage_9": {
    "health": 1247.4,
    "health_regeneration": 10,
    "physical_damage": 0,
    "magic_damage": 340,
    "physical_resist": 0.0375,
    "magic_resist": 0.075,
    "speed": 115,
    "dodge": 0.025,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 400,
    "mana_regeneration": 12.5,
    "power": 241.7074
  },
  "Queen_Mage_10": {
    "health": 1393.2,
    "health_regeneration": 15,
    "physical_damage": 0,
    "magic_damage": 373,
    "physical_resist": 0.05,
    "magic_resist": 0.1,
    "speed": 115,
    "dodge": 0.05,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 600,
    "mana_regeneration": 12.5,
    "power": 301.044
  },
  "Queen_Mage_11": {
    "health": 1539,
    "health_regeneration": 15,
    "physical_damage": 0,
    "magic_damage": 405,
    "physical_resist": 0.05,
    "magic_resist": 0.1,
    "speed": 115,
    "dodge": 0.05,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 600,
    "mana_regeneration": 12.5,
    "power": 322.38
  },
  "Queen_Mage_12": {
    "health": 1684.8,
    "health_regeneration": 15,
    "physical_damage": 0,
    "magic_damage": 437,
    "physical_resist": 0.05,
    "magic_resist": 0.1,
    "speed": 115,
    "dodge": 0.05,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 600,
    "mana_regeneration": 12.5,
    "power": 343.716
  },
  "Queen_Mage_13": {
    "health": 1830.6,
    "health_regeneration": 20,
    "physical_damage": 0,
    "magic_damage": 470,
    "physical_resist": 0.0625,
    "magic_resist": 0.125,
    "speed": 115,
    "dodge": 0.075,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 800,
    "mana_regeneration": 12.5,
    "power": 410.0726
  },
  "Queen_Mage_14": {
    "health": 1976.4,
    "health_regeneration": 20,
    "physical_damage": 0,
    "magic_damage": 502,
    "physical_resist": 0.0625,
    "magic_resist": 0.125,
    "speed": 115,
    "dodge": 0.075,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 800,
    "mana_regeneration": 12.5,
    "power": 432.5199
  },
  "Queen_Mage_15": {
    "health": 2122.2,
    "health_regeneration": 20,
    "physical_damage": 0,
    "magic_damage": 535,
    "physical_resist": 0.0625,
    "magic_resist": 0.125,
    "speed": 115,
    "dodge": 0.075,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 800,
    "mana_regeneration": 12.5,
    "power": 455.0934
  },
  "King_Warrior_1": {
    "health": 100,
    "health_regeneration": 0,
    "physical_damage": 100,
    "magic_damage": 0,
    "physical_resist": 0,
    "magic_resist": 0,
    "speed": 100,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 30
  },
  "King_Warrior_2": {
    "health": 260,
    "health_regeneration": 0,
    "physical_damage": 130,
    "magic_damage": 0,
    "physical_resist": 0,
    "magic_resist": 0,
    "speed": 105,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 49.5
  },
  "King_Warrior_3": {
    "health": 420,
    "health_regeneration": 15,
    "physical_damage": 160,
    "magic_damage": 0,
    "physical_resist": 0,
    "magic_resist": 0,
    "speed": 105,
    "dodge": 0,
    "stamina": 200,
    "stamina_regeneration": 15,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 91.5
  },
  "King_Warrior_4": {
    "health": 580,
    "health_regeneration": 15,
    "physical_damage": 190,
    "magic_damage": 0,
    "physical_resist": 0.05,
    "magic_resist": 0.025,
    "speed": 105,
    "dodge": 0,
    "stamina": 200,
    "stamina_regeneration": 15,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 118.7875
  },
  "King_Warrior_5": {
    "health": 740,
    "health_regeneration": 15,
    "physical_damage": 220,
    "magic_damage": 0,
    "physical_resist": 0.05,
    "magic_resist": 0.025,
    "speed": 105,
    "dodge": 0,
    "stamina": 200,
    "stamina_regeneration": 15,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 139.2125
  },
  "King_Warrior_6": {
    "health": 900,
    "health_regeneration": 15,
    "physical_damage": 250,
    "magic_damage": 0,
    "physical_resist": 0.05,
    "magic_resist": 0.025,
    "speed": 105,
    "dodge": 0,
    "stamina": 200,
    "stamina_regeneration": 15,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 159.6375
  },
  "King_Warrior_7": {
    "health": 1060,
    "health_regeneration": 20,
    "physical_damage": 280,
    "magic_damage": 0,
    "physical_resist": 0.075,
    "magic_resist": 0.0375,
    "speed": 105,
    "dodge": 0,
    "stamina": 400,
    "stamina_regeneration": 15,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 209.15
  },
  "King_Warrior_8": {
    "health": 1220,
    "health_regeneration": 20,
    "physical_damage": 310,
    "magic_damage": 0,
    "physical_resist": 0.075,
    "magic_resist": 0.0375,
    "speed": 105,
    "dodge": 0,
    "stamina": 400,
    "stamina_regeneration": 15,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 230.2875
  },
  "King_Warrior_9": {
    "health": 1380,
    "health_regeneration": 20,
    "physical_damage": 340,
    "magic_damage": 0,
    "physical_resist": 0.075,
    "magic_resist": 0.0375,
    "speed": 105,
    "dodge": 0,
    "stamina": 400,
    "stamina_regeneration": 15,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 251.425
  },
  "King_Warrior_10": {
    "health": 1540,
    "health_regeneration": 25,
    "physical_damage": 370,
    "magic_damage": 0,
    "physical_resist": 0.1,
    "magic_resist": 0.05,
    "speed": 105,
    "dodge": 0,
    "stamina": 600,
    "stamina_regeneration": 15,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 305.325
  },
  "King_Warrior_11": {
    "health": 1700,
    "health_regeneration": 25,
    "physical_damage": 400,
    "magic_damage": 0,
    "physical_resist": 0.1,
    "magic_resist": 0.05,
    "speed": 105,
    "dodge": 0,
    "stamina": 600,
    "stamina_regeneration": 15,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 327.175
  },
  "King_Warrior_12": {
    "health": 1860,
    "health_regeneration": 25,
    "physical_damage": 430,
    "magic_damage": 0,
    "physical_resist": 0.1,
    "magic_resist": 0.05,
    "speed": 105,
    "dodge": 0,
    "stamina": 600,
    "stamina_regeneration": 15,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 349.025
  },
  "King_Warrior_13": {
    "health": 2020,
    "health_regeneration": 30,
    "physical_damage": 460,
    "magic_damage": 0,
    "physical_resist": 0.125,
    "magic_resist": 0.0625,
    "speed": 105,
    "dodge": 0,
    "stamina": 800,
    "stamina_regeneration": 15,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 407.3125
  },
  "King_Warrior_14": {
    "health": 2180,
    "health_regeneration": 30,
    "physical_damage": 490,
    "magic_damage": 0,
    "physical_resist": 0.125,
    "magic_resist": 0.0625,
    "speed": 105,
    "dodge": 0,
    "stamina": 800,
    "stamina_regeneration": 15,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 429.875
  },
  "King_Warrior_15": {
    "health": 2340,
    "health_regeneration": 30,
    "physical_damage": 520,
    "magic_damage": 0,
    "physical_resist": 0.125,
    "magic_resist": 0.0625,
    "speed": 105,
    "dodge": 0,
    "stamina": 800,
    "stamina_regeneration": 15,
    "mana": 0,
    "mana_regeneration": 0,
    "power": 452.4375
  },
  "King_Archer_3": {
    "health": 378,
    "health_regeneration": 15,
    "physical_damage": 72,
    "magic_damage": 72,
    "physical_resist": 0,
    "magic_resist": 0,
    "speed": 110,
    "dodge": 0,
    "stamina": 100,
    "stamina_regeneration": 7.5,
    "mana": 100,
    "mana_regeneration": 7.5,
    "power": 86.2
  },
  "King_Archer_4": {
    "health": 522,
    "health_regeneration": 15,
    "physical_damage": 86,
    "magic_damage": 86,
    "physical_resist": 0.0375,
    "magic_resist": 0.0375,
    "speed": 110,
    "dodge": 0,
    "stamina": 100,
    "stamina_regeneration": 7.5,
    "mana": 100,
    "mana_regeneration": 7.5,
    "power": 111.155
  },
  "King_Archer_5": {
    "health": 666,
    "health_regeneration": 15,
    "physical_damage": 99,
    "magic_damage": 99,
    "physical_resist": 0.0375,
    "magic_resist": 0.0375,
    "speed": 110,
    "dodge": 0,
    "stamina": 100,
    "stamina_regeneration": 7.5,
    "mana": 100,
    "mana_regeneration": 7.5,
    "power": 129.43
  },
  "King_Archer_6": {
    "health": 810,
    "health_regeneration": 15,
    "physical_damage": 113,
    "magic_damage": 113,
    "physical_resist": 0.0375,
    "magic_resist": 0.0375,
    "speed": 110,
    "dodge": 0,
    "stamina": 100,
    "stamina_regeneration": 7.5,
    "mana": 100,
    "mana_regeneration": 7.5,
    "power": 147.92
  },
  "King_Archer_7": {
    "health": 954,
    "health_regeneration": 20,
    "physical_damage": 126,
    "magic_damage": 126,
    "physical_resist": 0.0563,
    "magic_resist": 0.0563,
    "speed": 110,
    "dodge": 0,
    "stamina": 200,
    "stamina_regeneration": 7.5,
    "mana": 200,
    "mana_regeneration": 7.5,
    "power": 194.8163
  },
  "King_Archer_8": {
    "health": 1098,
    "health_regeneration": 20,
    "physical_damage": 140,
    "magic_damage": 140,
    "physical_resist": 0.0563,
    "magic_resist": 0.0563,
    "speed": 110,
    "dodge": 0,
    "stamina": 200,
    "stamina_regeneration": 7.5,
    "mana": 200,
    "mana_regeneration": 7.5,
    "power": 213.953
  },
  "King_Archer_9": {
    "health": 1242,
    "health_regeneration": 20,
    "physical_damage": 153,
    "magic_damage": 153,
    "physical_resist": 0.0563,
    "magic_resist": 0.0563,
    "speed": 110,
    "dodge": 0,
    "stamina": 200,
    "stamina_regeneration": 7.5,
    "mana": 200,
    "mana_regeneration": 7.5,
    "power": 232.8672
  },
  "King_Archer_10": {
    "health": 1386,
    "health_regeneration": 25,
    "physical_damage": 167,
    "magic_damage": 167,
    "physical_resist": 0.075,
    "magic_resist": 0.075,
    "speed": 110,
    "dodge": 0,
    "stamina": 300,
    "stamina_regeneration": 7.5,
    "mana": 300,
    "mana_regeneration": 7.5,
    "power": 284.05
  },
  "King_Archer_11": {
    "health": 1530,
    "health_regeneration": 25,
    "physical_damage": 180,
    "magic_damage": 180,
    "physical_resist": 0.075,
    "magic_resist": 0.075,
    "speed": 110,
    "dodge": 0,
    "stamina": 300,
    "stamina_regeneration": 7.5,
    "mana": 300,
    "mana_regeneration": 7.5,
    "power": 303.6
  },
  "King_Archer_12": {
    "health": 1674,
    "health_regeneration": 25,
    "physical_damage": 194,
    "magic_damage": 194,
    "physical_resist": 0.075,
    "magic_resist": 0.075,
    "speed": 110,
    "dodge": 0,
    "stamina": 300,
    "stamina_regeneration": 7.5,
    "mana": 300,
    "mana_regeneration": 7.5,
    "power": 323.38
  },
  "King_Archer_13": {
    "health": 1818,
    "health_regeneration": 30,
    "physical_damage": 207,
    "magic_damage": 207,
    "physical_resist": 0.0938,
    "magic_resist": 0.0938,
    "speed": 110,
    "dodge": 0,
    "stamina": 400,
    "stamina_regeneration": 7.5,
    "mana": 400,
    "mana_regeneration": 7.5,
    "power": 378.4881
  },
  "King_Archer_14": {
    "health": 1962,
    "health_regeneration": 30,
    "physical_damage": 221,
    "magic_damage": 221,
    "physical_resist": 0.0938,
    "magic_resist": 0.0938,
    "speed": 110,
    "dodge": 0,
    "stamina": 400,
    "stamina_regeneration": 7.5,
    "mana": 400,
    "mana_regeneration": 7.5,
    "power": 398.9148
  },
  "King_Archer_15": {
    "health": 2106,
    "health_regeneration": 30,
    "physical_damage": 234,
    "magic_damage": 234,
    "physical_resist": 0.0938,
    "magic_resist": 0.0938,
    "speed": 110,
    "dodge": 0,
    "stamina": 400,
    "stamina_regeneration": 7.5,
    "mana": 400,
    "mana_regeneration": 7.5,
    "power": 419.104
  },
  "King_Mage_3": {
    "health": 340.2,
    "health_regeneration": 15,
    "physical_damage": 0,
    "magic_damage": 130,
    "physical_resist": 0,
    "magic_resist": 0,
    "speed": 107.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 200,
    "mana_regeneration": 15,
    "power": 80.77
  },
  "King_Mage_4": {
    "health": 469.8,
    "health_regeneration": 15,
    "physical_damage": 0,
    "magic_damage": 154,
    "physical_resist": 0.025,
    "magic_resist": 0.05,
    "speed": 107.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 200,
    "mana_regeneration": 15,
    "power": 103.3397
  },
  "King_Mage_5": {
    "health": 599.4,
    "health_regeneration": 15,
    "physical_damage": 0,
    "magic_damage": 178,
    "physical_resist": 0.025,
    "magic_resist": 0.05,
    "speed": 107.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 200,
    "mana_regeneration": 15,
    "power": 119.8518
  },
  "King_Mage_6": {
    "health": 729,
    "health_regeneration": 15,
    "physical_damage": 0,
    "magic_damage": 203,
    "physical_resist": 0.025,
    "magic_resist": 0.05,
    "speed": 107.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 200,
    "mana_regeneration": 15,
    "power": 136.4712
  },
  "King_Mage_7": {
    "health": 858.6,
    "health_regeneration": 20,
    "physical_damage": 0,
    "magic_damage": 227,
    "physical_resist": 0.0375,
    "magic_resist": 0.075,
    "speed": 107.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 400,
    "mana_regeneration": 15,
    "power": 181.1261
  },
  "King_Mage_8": {
    "health": 988.2,
    "health_regeneration": 20,
    "physical_damage": 0,
    "magic_damage": 251,
    "physical_resist": 0.0375,
    "magic_resist": 0.075,
    "speed": 107.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 400,
    "mana_regeneration": 15,
    "power": 198.2141
  },
  "King_Mage_9": {
    "health": 1117.8,
    "health_regeneration": 20,
    "physical_damage": 0,
    "magic_damage": 275,
    "physical_resist": 0.0375,
    "magic_resist": 0.075,
    "speed": 107.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 400,
    "mana_regeneration": 15,
    "power": 215.3021
  },
  "King_Mage_10": {
    "health": 1247.4,
    "health_regeneration": 25,
    "physical_damage": 0,
    "magic_damage": 300,
    "physical_resist": 0.05,
    "magic_resist": 0.1,
    "speed": 107.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 600,
    "mana_regeneration": 15,
    "power": 263.9135
  },
  "King_Mage_11": {
    "health": 1377,
    "health_regeneration": 25,
    "physical_damage": 0,
    "magic_damage": 324,
    "physical_resist": 0.05,
    "magic_resist": 0.1,
    "speed": 107.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 600,
    "mana_regeneration": 15,
    "power": 281.5775
  },
  "King_Mage_12": {
    "health": 1506.6,
    "health_regeneration": 25,
    "physical_damage": 0,
    "magic_damage": 348,
    "physical_resist": 0.05,
    "magic_resist": 0.1,
    "speed": 107.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 600,
    "mana_regeneration": 15,
    "power": 299.2415
  },
  "King_Mage_13": {
    "health": 1636.2,
    "health_regeneration": 30,
    "physical_damage": 0,
    "magic_damage": 373,
    "physical_resist": 0.0625,
    "magic_resist": 0.125,
    "speed": 107.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 800,
    "mana_regeneration": 15,
    "power": 351.7019
  },
  "King_Mage_14": {
    "health": 1765.8,
    "health_regeneration": 30,
    "physical_damage": 0,
    "magic_damage": 397,
    "physical_resist": 0.0625,
    "magic_resist": 0.125,
    "speed": 107.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 800,
    "mana_regeneration": 15,
    "power": 369.9419
  },
  "King_Mage_15": {
    "health": 1895.4,
    "health_regeneration": 30,
    "physical_damage": 0,
    "magic_damage": 421,
    "physical_resist": 0.0625,
    "magic_resist": 0.125,
    "speed": 107.5,
    "dodge": 0,
    "stamina": 0,
    "stamina_regeneration": 0,
    "mana": 800,
    "mana_regeneration": 15,
    "power": 388.1819
  }
};

// Базовые статы фигуры её уровня. Фолбэк — 3 уровень (стартовый), затем таблица без уровня:
// у части сочетаний младших уровней в книге баланса колонок нет (лучники и маги с 3-го).
export function unitBase(type, rank, level) {
  const lvl = Number(level || 3);
  return UNIT_STATS_BY_LEVEL[`${type}_${rank}_${lvl}`]
    || UNIT_STATS_BY_LEVEL[`${type}_${rank}_3`]
    || UNIT_STATS[`${type}_${rank}`]
    || {};
}

// Метки полей (RU) и порядок показа
export const STAT_LABELS = [
  ['health', 'Здоровье'],
  ['health_regeneration', 'Реген. здор.'],
  ['physical_damage', 'Физ. урон'],
  ['magic_damage', 'Маг. урон'],
  ['physical_resist', 'Физ. защита'],
  ['magic_resist', 'Маг. защита'],
  ['speed', 'Инициатива'],
  ['dodge', 'Уклонение'],
  ['stamina', 'Выносливость'],
  ['stamina_regeneration', 'Реген. вынос.'],
  ['mana', 'Мана'],
  ['mana_regeneration', 'Реген. маны'],
  ['power', 'Сила'],
];

// 🔴 Порядок статов для панелей. Экспорт ОБЯЗАТЕЛЕН: его импортируют PagePack.vue («Настройки фигур»)
// и InfoPanels.vue. Однажды генератор его не написал — сборка прошла с предупреждением webpack
// «export not found», а экран настроек фигур падал на пустой странице. Локали подписей живут в i18n,
// здесь только ключи и порядок.
export const STAT_KEYS = STAT_LABELS.map(([key]) => key);
